import Vue from "vue";
import Vuex from "vuex";
import authentication from '@/store/modules/authentication';
import user from '@/store/modules/user';
import leaderboard from '@/store/modules/leaderboard';
import activity from '@/store/modules/activity';
import articles from '@/store/modules/articles';
import team from '@/store/modules/team';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    //user: {namespaced: true,},
    authentication,
    user,
    leaderboard,
    activity,
    articles,
    team,

  },
  strict: debug,
})